import React, { useCallback, useContext, useEffect, useState } from 'react';
import SearchTP from './SearchTP';
import { useForm } from 'react-hook-form';
import TpAttributes from './TpAttributes';
import { Context } from '../../../../../states/Store';
import Referents from './Referents';
import {saveContextInstanceThirdparty} from "../../../../../services/edge/ContexteService";
import i18next from "i18next";
import {useAlert} from "../../../../../components/common/hooks/useAlert";

const addTpDefaultvalues = {
  tpInfos: null,
  thirdPartyId: null,
  referents: [],
};

const AddThirdParty = ({ context, setIsAddTpDialogOpen,parentId, associatedTP }) => {
  const [state, dispatch] = useContext(Context);
  const [currentStep, setCurrentStep] = useState(0);
  const {onSuccess} = useAlert();
  const formMethods = useForm({
    mode: 'onChange',
    delayError: 500,
    defaultValues: {
      contextInstanceId: context.id,
      tiersAttributes: context.tiersAttributes,
      parentId: parentId,
      ...addTpDefaultvalues
    },
  });

  const { setValue, watch, getValues } = formMethods;
  const tiersAttributes = watch('tiersAttributes');
  const tpToAdd = watch('tpInfos');
  const referents = watch('referents');

  useEffect(() => {
    return () => {
      setValue('tpInfos', null);
    };
  }, [setValue]);

  const setTpToAdd = useCallback((tp) => {
    setValue("thirdPartyId", tp.thirdpartyId);
    setValue('tpInfos', tp);
    setCurrentStep(1);
  }, [setValue]);

  const addContact = useCallback((email) => {
    if(email.trim() === '') return
    const referents = getValues("referents");
    setValue("referents", [...new Set([...referents, email.trim()])]);
  }, [setValue, getValues]);

  const deleteReferent = useCallback((email) => {
    const referents = getValues("referents");
    setValue("referents", referents.filter((r) => r!==email));
  }, [setValue, getValues]);


  const onEditAttribute = useCallback((data, attributeValue) => {
    const tiersAttributes = getValues('tiersAttributes');
    setValue('tiersAttributes', [
      ...tiersAttributes.map((att) => {
        if (att.attributeId === attributeValue.attributeId) {
          return { ...att, ...data };
        }
        return att;
      }),
    ]);
  }, [getValues, setValue]);

  const onValidateAttributes = useCallback(() => {
    setCurrentStep(2);
  }, []);

  const onCancelAttributes = useCallback(() => {
    setValue('tpInfos', null);
    setCurrentStep(0);
  }, [setValue]);

  const onCancelReferent = useCallback(() => {
    setValue('referents', []);
    setCurrentStep(1);
  }, [setValue]);

  const saveTiers = useCallback(async () => {
    const { tpInfos,
      ...payloadInfos
    } = getValues();
    const parentId = payloadInfos.parentId==='root'?-1:payloadInfos.parentId
    const payload = [{...payloadInfos,parentId}];
    await saveContextInstanceThirdparty(
        state.account.id,
        payload,
        dispatch);
    onSuccess(i18next.t("notifications.notifications.associated"))
    setIsAddTpDialogOpen(false);
  }, [state.account.id, dispatch, onSuccess,getValues,setIsAddTpDialogOpen]);

  const getCurrentStep = useCallback(() => {
    switch (currentStep) {
      case 0:
        return <SearchTP setTpToAdd={setTpToAdd} associatedTP={associatedTP} parentId={parentId}/>;
      case 1:
        return (
          <TpAttributes
            tpToAdd={tpToAdd}
            tiersAttributes={tiersAttributes}
            onEditAttribute={onEditAttribute}
            onCancel={onCancelAttributes}
            onValidate={onValidateAttributes}
          />
        );
      case 2:
        return <Referents
            tpToAdd={tpToAdd}
            addContact={addContact}
            deleteReferent={deleteReferent}
            referents={referents}
            onCancel={onCancelReferent}
            onValidate={saveTiers}
        />;
      default:
        return <></>
    }
  }, [currentStep, tiersAttributes, referents, addContact,
    associatedTP, deleteReferent, onCancelAttributes, onCancelReferent,
    onEditAttribute, parentId, saveTiers, setTpToAdd, tpToAdd, onValidateAttributes]);

  return <>{getCurrentStep()}</>;
};

export default AddThirdParty;
